export default "__VITE_ASSET__Z5XD_DfV__"